export default "__VITE_ASSET__CCj20L_n__"